import { APP_CONFIG } from "@config";
import { isTokenValid } from "../hooks/helpers";

/**
 * Backend, oturum açılmamış isteklerde de geçerli bir Bearer token bekliyor.
 * /User/Login dahil: Authorization header'ı olmadan uç 401 döner ve gövde hiç
 * işlenmez. Bu yüzden kullanıcı token'ı yokken misafir token'ı gönderilir.
 *
 * Token redux'ta tutulmuyor — hiçbir ekran ona bakmıyor ve prepareHeaders
 * içinden store'a yazmak (eski kodda olduğu gibi) oturum durumuyla yarışıyordu.
 */
const DEVICE_ID_KEY = "kiralasak.device_id";
const GUEST_TOKEN_KEY = "kiralasak.guest_token";

/**
 * Cihaz kimliği bir kez üretilip saklanır. Eski kod userAgent + platform +
 * eklenti sayısını hash'liyordu; tarayıcı güncellemesi bile kimliği
 * değiştirdiği için her seferinde yeni misafir kaydı açılıyordu.
 */
const getDeviceId = (): string => {
  let id = localStorage.getItem(DEVICE_ID_KEY);

  if (!id) {
    id =
      typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(DEVICE_ID_KEY, id);
  }

  return id;
};

const requestGuestToken = async (): Promise<string | undefined> => {
  try {
    const response = await fetch(`${APP_CONFIG.API_URL}/User/GuestUser`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        device_id: getDeviceId(),
        platform: "web",
        model_number: navigator.userAgent,
      }),
    });

    if (!response.ok) return undefined;

    const token = (await response.json())?.data?.access_token;
    if (typeof token !== "string" || !token) return undefined;

    localStorage.setItem(GUEST_TOKEN_KEY, token);
    return token;
  } catch {
    // Ağ hatası: token yok. Çağıran taraf Authorization göndermez,
    // "Bearer undefined" gibi bozuk bir header oluşmaz.
    return undefined;
  }
};

/** Aynı anda düşen isteklerin her birinin ayrı GuestUser çağırmasını önler. */
let inFlight: Promise<string | undefined> | null = null;

export const getGuestToken = async (): Promise<string | undefined> => {
  const cached = localStorage.getItem(GUEST_TOKEN_KEY);
  if (cached && isTokenValid(cached)) return cached;

  if (!inFlight) {
    inFlight = requestGuestToken().finally(() => {
      inFlight = null;
    });
  }

  return inFlight;
};

export const clearGuestToken = () => {
  localStorage.removeItem(GUEST_TOKEN_KEY);
};
